"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Conservative;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function Conservative() {
  return /*#__PURE__*/_react.default.createElement("svg", {
    width: "158",
    height: "156",
    viewBox: "0 0 158 156",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("ellipse", {
    cx: "79",
    cy: "77.9688",
    rx: "75",
    ry: "73.9062",
    stroke: "#059469",
    strokeWidth: "8"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M24 27.5139C4.77857 48.5139 40.0322 11.6399 25.967 25.5C11.9018 39.3601 4 58.305 4 77.9062C4 97.5073 11.9018 116.306 25.967 130.166C40.0322 144.026 59.1088 151.812 79 151.812",
    stroke: "#802AB8",
    strokeWidth: "8",
    strokeMiterlimit: "16",
    strokeLinecap: "round",
    strokeDasharray: "0.5 0.5"
  }));
}